define('core/mixins/withForumFollowing',[
    'underscore',
], function (
    _
) {
    'use strict';

    // Return the mixin properties and functions with a closure around
    // the getForum function, specified on a per-mixin basis
    function getForumFollowButtonWrapperView(getForum) {
        return {
            events: {
                'click [data-action=toggle-follow]': 'toggleFollow',
            },

            initialize: function () {
                this.bindToForum();
            },

            templateHelpers: function () {
                return {
                    isFollowing: this.getIsFollowing(),
                };
            },

            bindToForum: function () {
                var forumModel = getForum.call(this);

                if (!forumModel)
                    return;

                this.listenTo(forumModel, 'change:isFollowing', this.updateFollowedState);
            },

            getIsFollowing: function () {
                var forumModel = getForum.call(this);
                return forumModel && forumModel.get('isFollowing');
            },

            updateFollowedState: function () {
                this.$('[data-action=toggle-follow]').toggleClass('active', this.getIsFollowing());
            },

            toggleFollow: function (evt) {
                if (evt) {
                    evt.preventDefault();
                    evt.stopPropagation();
                }

                var forumModel = getForum.call(this);

                if (!forumModel)
                    return;

                forumModel.toggleFollowed();
                this.trigger('toggled:follow', evt);

            },
        };
    }

    function withForumFollowing(_getForum) {
        // A function to get the forum model for this view. If a special getter
        // is not given, forum is assumed to be the view's model.
        // This is passed to all the ForumFollowButtonWrapperView functions that
        // require the forum model.
        var getForum = _getForum || function () {
            return this.model;
        };

        var ForumFollowButtonWrapperView = getForumFollowButtonWrapperView(getForum);

        this.bindToForum = _.wrap(this.bindToForum, function (_bindToForum) {
            if (_bindToForum)
                _bindToForum.call(this);

            ForumFollowButtonWrapperView.bindToForum.call(this);
        });

        this.initialize = _.wrap(this.initialize, function (_initialize, options) {
            _initialize.call(this, options);
            ForumFollowButtonWrapperView.initialize.call(this, options);
        });

        this.templateHelpers = _.wrap(this.templateHelpers, function (_templateHelpers) {
            var helpers = _.isFunction(_templateHelpers) ?
                _templateHelpers.call(this) :
                _templateHelpers;

            return _.extend(
                ForumFollowButtonWrapperView.templateHelpers.call(this),
                helpers);
        });

        this.events = _.extend({}, ForumFollowButtonWrapperView.events, this.events);

        _.extend(this, _.pick(ForumFollowButtonWrapperView, 'toggleFollow', 'updateFollowedState', 'getIsFollowing'));
    }

    return withForumFollowing;
});

